import { each, get, includes, slice } from "lodash";
import { Link } from "components/chat/shared/LinkPreview";

export default (
  state = {},
  action: {
    type: string;
    chatId: string;
    meta: { chatId: string };
    messageId: string;
    text: string;
    fileAttachments: (File & { clientId: string })[];
    linkAttachments: Link[];
    linkAttachment: Link;
    urls: string[];
  },
) => {
  switch (action.type) {
    case "chat/COMPOSER/SET_MESSAGE_TO_QUOTE":
      return {
        ...state,
        [action.chatId]: {
          ...state[action.chatId],
          messageToQuoteId: action.messageId,
          messageToEditId: "",
        },
      };
    case "chat/COMPOSER/SET_MESSAGE_TO_EDIT":
      return {
        ...state,
        [action.chatId]: {
          ...state[action.chatId],
          messageToEditId: action.messageId,
          messageToQuoteId: "",
        },
      };
    case "chat/COMPOSER/SET_TEXT":
      return {
        ...state,
        [action.chatId]: {
          ...state[action.chatId],
          text: action.text,
        },
      };
    case "chat/COMPOSER/SET_FILE_ATTACHMENTS":
      return {
        ...state,
        [action.chatId]: {
          ...state[action.chatId],
          fileAttachments: action.fileAttachments,
        },
      };
    case "chat/COMPOSER/SET_IMAGE_ATTACHMENTS":
      return {
        ...state,
        [action.chatId]: {
          ...state[action.chatId],
          imageAttachments: action.fileAttachments,
        },
      };
    case "chat/COMPOSER/ADD_LINK_ATTACHMENTS": {
      const linkAttachments = state[action.chatId]?.linkAttachments || {};
      each(action.linkAttachments, (link) => {
        linkAttachments[link.url] = link;
      });

      return {
        ...state,
        [action.chatId]: {
          ...state[action.chatId],
          linkAttachments,
        },
      };
    }
    case "chat/COMPOSER/ADD_LINK_ATTACHMENT":
      return {
        ...state,
        [action.chatId]: {
          ...state[action.chatId],
          linkAttachments: {
            ...state[action.chatId]?.linkAttachments,
            [action.linkAttachment.url]: {
              ...state[action.chatId]?.linkAttachments[
                action.linkAttachment.url
              ],
              ...action.linkAttachment,
            },
          },
        },
      };
    case "chat/COMPOSER/CLEAN_LINK_ATTACHMENTS": {
      const cleanedLinkAttachments = {};
      each(state[action.chatId]?.linkAttachments, (link) => {
        if (includes(action.urls, link.url))
          cleanedLinkAttachments[link.url] = link;
      });

      return {
        ...state,
        [action.chatId]: {
          ...state[action.chatId],
          linkAttachments: cleanedLinkAttachments,
        },
      };
    }
    case "chat/COMPOSER/ADD_FILE_ATTACHMENTS":
      return {
        ...state,
        [action.chatId]: {
          ...state[action.chatId],
          fileAttachments: [
            ...(get(state, [action.chatId, "fileAttachments"]) ?? []),
            ...action.fileAttachments,
          ],
        },
      };
    case "chat/COMPOSER/ADD_IMAGE_ATTACHMENTS":
      return {
        ...state,
        [action.chatId]: {
          ...state[action.chatId],
          imageAttachments: [
            ...(get(state, [action.chatId, "imageAttachments"]) ?? []),
            ...action.fileAttachments,
          ],
        },
      };
    case "chat/COMPOSER/ADD_OR_UPDATE_IMAGE_ATTACHMENTS": {
      const currentImageAttachments = get(
        state,
        [action.chatId, "imageAttachments"],
        [],
      );
      const updatedImageAttachments = action.fileAttachments.reduce(
        (nextState, newImage) => {
          const index = nextState.findIndex(
            (img) => img.clientId === newImage.clientId,
          );

          if (index !== -1) {
            return [
              ...slice(nextState, 0, index),
              { ...nextState[index], ...newImage },
              ...slice(nextState, index + 1),
            ];
          } else {
            return [...nextState, newImage];
          }
        },
        currentImageAttachments,
      );

      return {
        ...state,
        [action.chatId]: {
          ...state[action.chatId],
          imageAttachments: updatedImageAttachments,
        },
      };
    }
    case "chat/COMPOSER/ADD_OR_UPDATE_FILE_ATTACHMENTS": {
      const currentFileAttachments = get(
        state,
        [action.chatId, "fileAttachments"],
        [],
      );
      const updatedFileAttachments = action.fileAttachments.reduce(
        (nextState, newFile) => {
          const index = nextState.findIndex(
            (file) => file.clientId === newFile.clientId,
          );

          if (index !== -1) {
            return [
              ...slice(nextState, 0, index),
              { ...nextState[index], ...newFile },
              ...slice(nextState, index + 1),
            ];
          } else {
            return [...nextState, newFile];
          }
        },
        currentFileAttachments,
      );

      return {
        ...state,
        [action.chatId]: {
          ...state[action.chatId],
          fileAttachments: updatedFileAttachments,
        },
      };
    }
    case "chat/SEND_MESSAGE":
      return {
        ...state,
        [action.meta.chatId]: {
          text: "",
          messageToQuoteId: "",
          messageToEditId: "",
          fileAttachments: null,
        },
      };
    default:
      return state;
  }
};
